const AttachedDocumentIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="attached-document"
  >
    <rect width="32" height="32" fill="white" />
    <path
      d="M15.7144 20.2429V13.1984C15.7144 12.7195 15.5026 12.265 15.1358 11.9569V11.9569C14.2313 11.1971 12.9117 11.1971 12.0072 11.9569V11.9569C11.6404 12.265 11.4286 12.7195 11.4286 13.1984V21.4845C11.4286 22.5704 12.0154 23.5715 12.9628 24.102L14.2486 24.822C15.1592 25.332 16.2695 25.332 17.1802 24.822L18.4659 24.102C19.4133 23.5715 20.0001 22.5704 20.0001 21.4845V16.0429"
      stroke={color}
      strokeLinecap="round"
    />
    <path
      d="M8 1.5H17.8929V9.11658C17.8929 9.93946 18.5558 10.6087 19.3786 10.6165L27 10.6888V28C27 29.3807 25.8807 30.5 24.5 30.5H8C6.61929 30.5 5.5 29.3807 5.5 28V4C5.5 2.61929 6.61929 1.5 8 1.5Z"
      stroke={color}
    />
    <path
      d="M26.9643 10.1071L18.3928 1.53571"
      stroke={color}
      strokeLinecap="round"
    />
  </svg>
);

export default AttachedDocumentIcon;
